"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {};
//# sourceMappingURL=editableText.style.js.map